import React, { useCallback, useEffect } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import DashBoardRoutes from './DashBoardRoutes';
import Login from '../pages/Login';
import RemoteAcess from '../pages/RemoteAcess';

const Routes: React.FC = () => {
  const { token } = useAuth();
  const { pathname } = useLocation();
  const { push } = useHistory();

  const handleRedirect = useCallback(
    (pathLink: string) => {
      push(pathLink);
    },
    [push],
  );

  useEffect(() => {
    if (pathname === '/' && token) {
      handleRedirect('/meu-perfil');
    }
  }, [token]);

  return (
    <Switch>
      <Route path="/remote-auth" exact component={RemoteAcess} />
      <Route path="/" exact component={Login} />
      <DashBoardRoutes />
    </Switch>
  );
};

export default Routes;
